module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [(_vm.record) ? _c('v-card-title', {
    staticClass: "pb-0 overline"
  }, [_vm._v("\n    #" + _vm._s(_vm.record.id) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [(_vm.record && _vm.record.patient) ? _c('div', [_vm._v("\n      Billing address: " + _vm._s(_vm.record.patient.billing_address || 'n/a')), _c('br'), _vm._v("\n      Birthday: " + _vm._s(_vm.record.patient.date_of_birth)), _c('br')]) : _vm._e()])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.record.medical_aid) ? _c('medical-aid-card', {
    model: {
      value: (_vm.record.medical_aid),
      callback: function($$v) {
        _vm.$set(_vm.record, "medical_aid", $$v)
      },
      expression: "record.medical_aid"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fc90c6c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards/RecordCard.vue
// module id = 1651
// module chunks = 2